import * as yup from 'yup';

export const StudentsValidationSchema = yup.object().shape({
  name: yup.string().required( 'El nombre es requerido' ),
  lastname: yup.string().required( 'El apellido es requerido' ),
  email: yup.string().required( 'El correo es requerido' ),
});
